<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import {
  batchComputed,
  authComputed,
  batchListMethod,
  resourceListMethod,
  userListMethod,
  departmentListMethod,
  departmentComputed,
} from '@state/helpers'

export default {
  page: {
    title: 'Add Resource',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    'b-overlay': BOverlay,
  },
  data() {
    return {
      title: '',
      description: '',
      resourceError: null,
      isResourceError: false,
      isLoading: false,
      show: false,
      batchlist: [],
      document: [],
      videoUrl: [],
      videoUrl1: [],
      videoTitle: [],
      assignedTo: [],
      sizeError: false,
      typeError: false,
      missingError: false,
      videoError: false,
      collegelist: [],
      classlist: [],
      collegeId: '',
      collegeClass: [],
      departmentId: [],
      departmentlist: [],
    }
  },
  computed: {
    ...batchComputed,
    ...authComputed,
    ...departmentComputed,
  },
  mounted() {
    this.collegeId = this.profileData.college_id
    this.getDepartments()
    if (this.role === 'teacher') {
      this.collegeClass = this.profileData.collegeClass
      this.departmentId.push(this.profileData.department)
    }
    if (this.role === 'hod') {
      this.departmentId.push(this.profileData.department)
      this.getClasses()
    }
  },
  methods: {
    ...batchListMethod,
    ...resourceListMethod,
    ...userListMethod,
    ...departmentListMethod,

    // save resource method
    saveResource() {
      this.isResourceError = false
      if (this.videoUrl1.length !== 0 && this.videoTitle.length === 0) {
        this.videoError = true
        this.missingError = false
      } else if (this.videoUrl1.length === 0 && this.videoTitle.length !== 0) {
        this.videoError = true
        this.missingError = false
      } else if (this.videoUrl1.length !== this.videoTitle.length) {
        this.videoError = true
        this.missingError = false
      } else {
        this.videoError = false
        this.missingError = false
        let i = 0
        for (i = 0; i < this.videoTitle.length; i++) {
          this.videoUrl.push({
            title: this.videoTitle[i],
            url: this.videoUrl1[i],
          })
        }
      }
      if (this.document.length === 0 && this.videoUrl.length === 0) {
        this.missingError = true
      } else {
        this.missingError = false
      }
      if (
        !this.sizeError &&
        !this.typeError &&
        !this.missingError &&
        !this.videoError
      ) {
        let Data = {}
        Data.title = this.title
        Data.description = this.description
        Data.assigned_to = this.assignedTo
        Data.platform_id = this.currentUser.user.platform_id
        Data.collegeClass = this.collegeClass
        Data.department = this.departmentId
        Data.college_id = this.collegeId
        if (this.document.length !== 0) {
          Data.document = this.document
        }
        if (this.videoUrl.length !== 0 && this.videoTitle.length !== 0) {
          Data.video_url = this.videoUrl
        }
        this.isLoading = true
        this.addResourceData({ Data })
          .then((batch) => {
            this.isLoading = false
            this.$router.push({ name: 'resource.list' })
          })
          .catch((error) => {
            this.isLoading = false
            var getError = new ErrorWrapper(error)
            this.resourceError = getError.message
            this.isResourceError = true
            window.scrollTo(0, 0)
          })
      }
    },

    handleFileUpload(event) {
      this.document = []
      this.sizeError = false
      this.typeError = false
      let files = event.target.files || event.dataTransfer.files
      let i = 0
      for (i = 0; i < files.length; i++) {
        if (files[i].type === 'application/pdf') {
          if (files[i].size <= 8000000) {
            let obj = {}
            obj['name'] = files[i].name
            const reader = new FileReader()
            reader.readAsDataURL(files[i])
            reader.onload = () => {
              obj['data'] = reader.result
            }
            this.document.push(obj)
          } else {
            this.sizeError = true
          }
        } else {
          this.typeError = true
        }
      }
    },

    tagValidator(tag) {
      /* eslint-disable */
      var res = tag.match(
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
      )
      if (res === null) {
      } else {
        return tag
      }
    },

    restrictChars(event) {
      if (event.charCode === 32 && !this.title.length) {
        event.preventDefault()
      } else {
        if (
          (event.charCode >= 65 && event.charCode <= 90) ||
          (event.charCode >= 97 && event.charCode <= 122) ||
          event.charCode === 32
        ) {
          return true
        } else {
          event.preventDefault()
        }
      }
    },

    restrictChars1(event) {
      if (event.charCode === 32 && !this.description.length) {
        event.preventDefault()
      } else {
        return true
      }
    },
    getColleges() {
      this.fetchCollegeList()
        .then((college) => {
          var listitems = []
          listitems.push({
            value: null,
            text: 'Select College',
            disabled: true,
          })
          college.forEach((element) => {
            var ele = {}
            ele.text = element.name
            ele.value = element._id
            listitems.push(ele)
          })
          listitems.push({
            value: 'All',
            text: 'All',
          })
          this.collegelist = listitems
        })
        .catch((_error) => {})
    },

    getClasses() {
      this.fetchClassList()
        .then((classes) => {
          var listitems = []
          classes.forEach((element) => {
            var ele = {}
            let i = 0
            for (i = 0; i < this.departmentId.length; i++) {
              if (this.departmentId[i] === element.department) {
                ele.text = element.name
                ele.value = element._id
                ele.college = element.college_id
                listitems.push(ele)
              }
            }
          })
          this.classlist = listitems
          if (this.classlist.length > 1) {
            this.classlist.unshift({
              value: 'All',
              text: 'All',
            })
          }
        })
        .catch((_error) => {})
    },

    getDepartments() {
      this.departmentId = []
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchDepartmentList({ filter })
        .then((dept) => {
          var listitems = []
          dept.docs.forEach((element) => {
            if (element.college_id === this.collegeId) {
              var ele = {}
              ele.text = element.name
              ele.value = element._id
              listitems.push(ele)
            }
          })
          this.departmentlist = listitems
        })
        .catch((_error) => {})
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="show" :opacity="0.6" rounded="sm">
          <b-card>
            * Mandatory Fields<br /><br />
            <b-alert
              v-model="isResourceError"
              variant="danger"
              v-html="resourceError"
            ></b-alert>
            <p v-if="missingError" style="color: red"
              >Please Add Document or Video URL</p
            >
            <p v-if="videoError" style="color: red"
              >Please Add Title/URL for Video</p
            >
            <b-form
              data-parsley-validate
              novalidate
              @submit.prevent="saveResource"
            >
              <b-form-group label="Title*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="title"
                  type="text"
                  placeholder="Enter Resource Title"
                  @keypress="restrictChars($event)"
                ></b-form-input>
              </b-form-group>

              <b-form-group label="Description*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="description"
                  type="text"
                  placeholder="Enter Resource Description"
                  @keypress="restrictChars1($event)"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                label="Upload PDF File(Max Size:8 MB)"
                label-for="document"
              >
                <b-form-file
                  id="document"
                  ref="file"
                  type="file"
                  placeholder="Click here to add file"
                  accept=".pdf"
                  multiple
                  @change="handleFileUpload"
                ></b-form-file>
              </b-form-group>
              <p v-if="sizeError" style="color: red"
                >Please upload file less than 8 MB</p
              >
              <p v-if="typeError" style="color: red"
                >Please upload only pdf files</p
              >
              <b-form-group
                label="Video URL(Multiple URLs can be added,add embedded links) "
                label-for="videoUrl1"
              >
                <p style="color: black; background: yellow"
                  >Note:
                  <a
                    href="https://wpexplorer-themes.com/total/docs/get-embed-urllink-youtube-video/"
                    target="_blank"
                    style="color: black; text-decoration: underline"
                    >Click here </a
                  >to know about embedded url/link</p
                >
                <b-form-tags
                  v-model="videoTitle"
                  tag-pills
                  class="mb-2"
                  separator=","
                  placeholder="Enter Video Title separated by comma"
                ></b-form-tags>
                <b-form-tags
                  v-model="videoUrl1"
                  tag-pills
                  class="mb-2"
                  separator=","
                  placeholder="Enter associated Video URL in sequence separated by comma"
                  :tag-validator="tagValidator"
                  invalid-tag-text="Invalid URL"
                ></b-form-tags>
              </b-form-group>
              <b-form-group
                v-if="role !== 'teacher' && role !== 'hod'"
                label="Select Department*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="departmentId"
                  :options="departmentlist"
                  multiple
                  @change="getClasses"
                ></b-form-select>
              </b-form-group>

              <b-form-group
                v-if="role !== 'teacher'"
                label="Select Class*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="collegeClass"
                  :options="classlist"
                  multiple
                ></b-form-select>
              </b-form-group>
              <b-form-group id="button-group" class="mt-4">
                <b-button
                  v-if="!isLoading"
                  type="submit"
                  variant="primary"
                  style="color: white"
                  >Save</b-button
                >
                <b-button
                  v-else
                  type="submit"
                  variant="primary"
                  class="btn-block"
                  disabled
                >
                  <b-spinner small></b-spinner>Loading...
                </b-button>
              </b-form-group>
              <a class="cancel-anchor" href="/resource-list"
                ><b-button
                  v-if="!isLoading"
                  class="cancel"
                  type="button"
                  variant="primary"
                  >Cancel</b-button
                ></a
              >
            </b-form>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
<style>
.cancel {
  background-color: grey;
}
.cancel:hover {
  background-color: grey !important;
}
.cancel:active {
  background-color: grey !important;
}

.cancel-anchor {
  color: white !important;
}
.cancel-anchor:hover {
  color: white;
}
</style>
